/* tslint:disable */
/* eslint-disable */
/**
 * Jack Burton Internal API
 * API for the Jack Burton platform
 *
 * The version of the OpenAPI document: v1 App
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime.js';
import type { ParticipantRole } from './ParticipantRole.js';
import {
    ParticipantRoleFromJSON,
    ParticipantRoleFromJSONTyped,
    ParticipantRoleToJSON,
} from './ParticipantRole.js';

/**
 * 
 * @export
 * @interface MatchedStatementSentence
 */
export interface MatchedStatementSentence {
    /**
     * 
     * @type {ParticipantRole}
     * @memberof MatchedStatementSentence
     */
    role?: ParticipantRole;
    /**
     * 
     * @type {number}
     * @memberof MatchedStatementSentence
     */
    score?: number;
    /**
     * 
     * @type {number}
     * @memberof MatchedStatementSentence
     */
    contactId?: number;
    /**
     * 
     * @type {number}
     * @memberof MatchedStatementSentence
     */
    utteranceId?: number;
    /**
     * 
     * @type {number}
     * @memberof MatchedStatementSentence
     */
    startOffset?: number;
    /**
     * 
     * @type {number}
     * @memberof MatchedStatementSentence
     */
    endOffset?: number;
    /**
     * 
     * @type {number}
     * @memberof MatchedStatementSentence
     */
    sentenceStartOffset?: number;
    /**
     * 
     * @type {number}
     * @memberof MatchedStatementSentence
     */
    sentenceEndOffset?: number;
    /**
     * 
     * @type {number}
     * @memberof MatchedStatementSentence
     */
    sentenceStartOffsetMs?: number;
    /**
     * 
     * @type {number}
     * @memberof MatchedStatementSentence
     */
    sentenceEndOffsetMs?: number;
}

/**
 * Check if a given object implements the MatchedStatementSentence interface.
 */
export function instanceOfMatchedStatementSentence(value: object): boolean {
    return true;
}

export function MatchedStatementSentenceFromJSON(json: any): MatchedStatementSentence {
    return MatchedStatementSentenceFromJSONTyped(json, false);
}

export function MatchedStatementSentenceFromJSONTyped(json: any, ignoreDiscriminator: boolean): MatchedStatementSentence {
    if (json == null) {
        return json;
    }
    return {
        
        'role': json['role'] == null ? undefined : ParticipantRoleFromJSON(json['role']),
        'score': json['score'] == null ? undefined : json['score'],
        'contactId': json['contactId'] == null ? undefined : json['contactId'],
        'utteranceId': json['utteranceId'] == null ? undefined : json['utteranceId'],
        'startOffset': json['startOffset'] == null ? undefined : json['startOffset'],
        'endOffset': json['endOffset'] == null ? undefined : json['endOffset'],
        'sentenceStartOffset': json['sentenceStartOffset'] == null ? undefined : json['sentenceStartOffset'],
        'sentenceEndOffset': json['sentenceEndOffset'] == null ? undefined : json['sentenceEndOffset'],
        'sentenceStartOffsetMs': json['sentenceStartOffsetMs'] == null ? undefined : json['sentenceStartOffsetMs'],
        'sentenceEndOffsetMs': json['sentenceEndOffsetMs'] == null ? undefined : json['sentenceEndOffsetMs'],
    };
}

export function MatchedStatementSentenceToJSON(value?: MatchedStatementSentence | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'role': ParticipantRoleToJSON(value['role']),
        'score': value['score'],
        'contactId': value['contactId'],
        'utteranceId': value['utteranceId'],
        'startOffset': value['startOffset'],
        'endOffset': value['endOffset'],
        'sentenceStartOffset': value['sentenceStartOffset'],
        'sentenceEndOffset': value['sentenceEndOffset'],
        'sentenceStartOffsetMs': value['sentenceStartOffsetMs'],
        'sentenceEndOffsetMs': value['sentenceEndOffsetMs'],
    };
}

